import {LightProduct} from '../../interfaces/product-management/light-product';
import {Product} from '../../interfaces/product-management/product';


export class LightProductFactory {

  /**
   *
   * @param lightProduct
   */
  public static fromObject(lightProduct: any): LightProduct {
    return new class implements LightProduct {
      id: number = lightProduct.id;
      name: string = lightProduct.name;
      shortName: string = lightProduct.short_name;
      customId: number = lightProduct.custom_id;
    };
  }

  /**
   *
   * @param lightProducts
   */
  public static fromArray(lightProducts: any[]): LightProduct[] {
    return lightProducts.map((_lightProduct) => {
      return LightProductFactory.fromObject(_lightProduct);
    });
  }

  /**
   *
   */
  public static fromProduct(product: Product): LightProduct {
    return product;
  }

}
